<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">About Magicom
                                </h1>
                                <p class="lead  text-white">
                                    We build one stop solution for various AI applications and make enterprise intellgence easier than ever.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        
        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/who_are_we.jpg" class="img-fluid">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <h3 class="text-white">Who We Are</h3>
                            <p class="lead text-white">Magicom is the world's leading enterprise intelligence solution provider. We provide technical solutions and supports for enterprises under various application senarios. We are committed to serving our customers with</p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                        <h6 class="mb-0 text-white">Guaranteed high quality</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-credit-card"></badge>
                                        <h6 class="mb-0 text-white">Amazing low price</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-satisfied"></badge>
                                        <h6 class="mb-0 text-white">Dedicated support team</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img v-lazy="'img/our_mission.jpg'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Full-stack AI solutions</h4>
                                <p class="lead text-italic text-white">We are committed to providing full-stack AI services and solutions for helping enterprises quickly realize intelligent transformation. </p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <h3 class="text-white">Our Mission</h3>
                            <p class="lead text-white">With the vigorous development of machine learning, especially deep learning technologies, artificial intelligence has brought the era of technology into a new era. Today's smart computers can recognize images, voices, and videos; translate languages; generate text, images, and videos to help people complete many repetitive tasks. With the advent of the artificial intelligence era, the intellgence of enterprises becomes a new trend. The key to achieving this is whether they can use powerful artificial intelligence technology to build a complete set of platforms to efficiently process massive amounts of enterprises' data.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <home-careers></home-careers>
    </div>
</template>

<script>
import HomeCareers from "./components/HomeCareers"
export default {
  name: "about",
  components: {
      HomeCareers
  }
};
</script>
